import React from 'react';
import { TrendingUp, Shield, CheckCircle, AlertCircle, History } from 'lucide-react';

const StatsCards = ({ stats, formatPrice, variant = 'desktop' }) => {
  const statItems = [
    { 
      label: 'Total Value', 
      value: formatPrice(stats.totalAmount), 
      icon: TrendingUp, 
      color: 'text-[#ff660e]',
      bgColor: 'bg-orange-50',
      borderColor: 'border-orange-200'
    },
    { 
      label: 'Active', 
      value: stats.held, 
      icon: Shield, 
      color: 'text-green-600',
      bgColor: 'bg-green-50',
      borderColor: 'border-green-200'
    },
    { 
      label: 'Completed', 
      value: stats.released, 
      icon: CheckCircle, 
      color: 'text-blue-600',
      bgColor: 'bg-blue-50',
      borderColor: 'border-blue-200'
    },
    { 
      label: 'Disputed', 
      value: stats.disputed, 
      icon: AlertCircle, 
      color: 'text-orange-600',
      bgColor: 'bg-orange-50',
      borderColor: 'border-orange-200'
    },
    { 
      label: 'Total', 
      value: stats.total, 
      icon: History, 
      color: 'text-gray-600',
      bgColor: 'bg-gray-50',
      borderColor: 'border-gray-200'
    },
  ];

  const isMobile = variant === 'mobile';
  const gridCols = isMobile ? 'grid-cols-2' : 'grid-cols-5';
  const padding = isMobile ? 'p-3' : 'p-4';

  return (
    <div className={`grid ${gridCols} gap-3`}>
      {statItems.map((stat, index) => (
        <div 
          key={index} 
          className={`${stat.bgColor} rounded-xl ${padding} shadow-sm border ${stat.borderColor} hover:shadow-md transition-shadow`}
        >
          <div className="flex items-center justify-between">
            <div>
              <p className={`text-gray-600 font-medium ${isMobile ? 'text-xs' : 'text-sm'}`}>
                {stat.label}
              </p>
              <p className={`font-bold text-black mt-1 ${isMobile ? 'text-base' : 'text-xl'}`}>
                {stat.value}
              </p>
            </div>
            <div className={`p-2 rounded-lg ${stat.bgColor} border ${stat.borderColor}`}>
              <stat.icon className={`${isMobile ? 'w-4 h-4' : 'w-5 h-5'} ${stat.color}`} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default StatsCards;